/**
 * ============================================================
 *
 * [compare]
 * 
 * ============================================================
 */

/* 製品切替 */
document.addEventListener('DOMContentLoaded', async () => {

    const compare = document.getElementById('compare_content');
    if (!compare) return;

    const selects = compare.querySelectorAll('.js-compare-select');
    let products = {};

    /* ===============================
       JSON_PATHS を待つ
    =============================== */
    const waitForJSONPath = () => {
        return new Promise(resolve => {
            if (window.JSON_PATHS?.products) {
                resolve(window.JSON_PATHS.products);
                return;
            }
            const timer = setInterval(() => {
                if (window.JSON_PATHS?.products) {
                    clearInterval(timer);
                    resolve(window.JSON_PATHS.products);
                }
            }, 30);
        });
    };

    /* ===============================
       JSON読み込み
    =============================== */
    try {
        const jsonUrl = await waitForJSONPath();
        const res = await fetch(jsonUrl);
        if (!res.ok) throw new Error(res.status);
        products = await res.json();
    } catch (e) {
        console.error('商品JSONの読み込みに失敗', e);
        return;
    }

    /* ===============================
       列更新処理
    =============================== */
    function updateColumn(colIndex, productId) {
        const product = products[productId];
        if (!product) return;

        const fadeTargets = compare.querySelectorAll(
            `.item .compare-col[data-col="${colIndex}"] .fade-target`
        );

        fadeTargets.forEach(el => el.classList.add('is-fade-out'));

        setTimeout(() => {

            /* ヘッダー更新 */
            const headCol = compare
                .querySelector('.item--head')
                ?.querySelector(`.compare-col[data-col="${colIndex}"]`);

            const headFade = headCol?.querySelector('.fade-target');

            if (headFade) {
                headFade.dataset.product = productId;
    
                headFade.querySelector('h3').innerHTML = product.title;

                updateStickyTitle(colIndex, product.title, productId);

                const img = headFade.querySelector('figure img');
                if (img) {
                    img.src = product.img;
                    img.alt = product.title;
                }
            }

            /* スペック更新 */
            compare.querySelectorAll('.item[data-spec-key]').forEach(row => {
                const key = row.dataset.specKey;
                const cell = row.querySelector(
                    `.compare-col[data-col="${colIndex}"] .fade-target`
                );
                if (cell) {
                    cell.innerHTML = product.specs[key] || '-';
                }
            });

            fadeTargets.forEach(el => {
                el.classList.remove('is-fade-out');
                el.classList.add('is-fade-in');
            });

            setTimeout(() => {
                fadeTargets.forEach(el => el.classList.remove('is-fade-in'));
            }, 300);

        }, 300);
    }

    function updateStickyTitle(colIndex, titleText, productId) {
        const li = document.querySelector(
            `#compare_content .sticky-title-list li[data-col="${colIndex}"]`
        );
        if (li) {
            li.dataset.product = productId;
            const item = li.querySelector('.element');
            if (item) {
                item.innerHTML = titleText;
            }

        }
    }

    /* ===============================
       初期描画
    =============================== */
    const defaultIds = ['basic', 'basic_arm', 'plus'];

    selects.forEach((select, index) => {
        if (defaultIds[index]) select.value = defaultIds[index];
        updateColumn(index, select.value);
        select.addEventListener('change', () => {
            updateColumn(index, select.value);
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const compare = document.getElementById('compare_content');
    const headItem = compare.querySelector('.item--head');
    if (!compare || !headItem) return;
    let observer;
    const BREAKPOINT = 768; // ← SP判定の幅
    function setupObserver() {
        const w = window.innerWidth;
        let raw;
        let max;
        if (w <= BREAKPOINT) {
            /* ========= SP用設定 ========= */
            raw = -(w * 300 / 375);
            max = -300;
        } else {
            /* ========= PC用設定 ========= */
            raw = -(w * 200 / 1400);
            max = -200;
        }
        // 下限でクランプ（-200px / -120px を超えない）
        const marginTop = Math.max(raw, max);
        // 既存Observerを破棄
        if (observer) observer.disconnect();
        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    compare.classList.add('is-sticky');
                } else {
                    compare.classList.remove('is-sticky');
                }
            });
        }, {
            root: null,
            threshold: 0,
            rootMargin: `${marginTop}px 0px 0px 0px`
        });
        observer.observe(headItem);
    }
    // 初期化
    setupObserver();
    // リサイズ追従
    window.addEventListener('resize', setupObserver);
});